import { reactive } from 'vue';
import { acessoUtils } from '../util/acesso.utils.js';
import { cookieUtils } from '../util/cookie.utils.js';

export const Authenticator = reactive({
    jwt: null,
    userConnection: null,
    pessoaLogada: null,
    isAuthenticated: false,

    async setJwt(novoJwt) {
        if (!!novoJwt && this.jwt != novoJwt) {
            this.jwt = novoJwt;
        } else {
            this.jwt = cookieUtils.adquirirCookie("jwt");
        }
        return this.jwt;
    },

    async getJwt() {
        if (!this.jwt) {
            return await this.setJwt();
        }

        return this.jwt;
    },

    async setUserConnection(novoUserConnection) {
        if (!!novoUserConnection && this.userConnection != novoUserConnection) {
            this.userConnection = novoUserConnection;
        } else {
            this.userConnection = await acessoUtils.adquirirUserConnection();
        }
        return this.userConnection;
    },

    async getUserConnection() {
        if (!this.userConnection) {
            return await this.setUserConnection();
        }

        return this.userConnection;
    },

    
    async setPessoaLogada(novaPessoaLogada) {
        if (!!novaPessoaLogada && this.pessoaLogada != novaPessoaLogada) {
            this.pessoaLogada = novaPessoaLogada;
        } else {
            this.pessoaLogada = await acessoUtils.loadPessoaLogada();
        }
        return this.pessoaLogada;
    },

    async getPessoaLogada() {
        if (!this.pessoaLogada) {
            return await this.setPessoaLogada()
        }
        return this.pessoaLogada
    },

    async getIsAuthenticated() {
        const jwt = await this.getJwt();
        const userConnection = await this.getUserConnection();
        const pessoaLogada = await this.getPessoaLogada();
        return !!jwt && !!userConnection && !!pessoaLogada
    }
})